import React, { Component } from 'react';
import { Modal, Checkbox, message, DatePicker } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import addToDownloadSite from '../../shared/addToDownloadSite';
import moment from 'moment';

const { MonthPicker } = DatePicker;
const DefaultTypes = {
    all: false,
    detail: false,
    allCure: false,
    detailCure: false,
};

class ExportModal extends Component {
    state = {
        visible: false,
        types: {...DefaultTypes},
        monthParams: {},
    }

    show = () => {
        this.setState({ visible: true });
        this.queryDate();
    }

    queryDate= () => {
        const { monthParams } =this.state
        const options = {
            method: 'POST',
            url: API_URL.home.queryEffectiveDate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                monthParams.allSolidifyDate = date;
                monthParams.detailSolidifyDate = date;
                this.setState({ monthParams });
            }
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({
            visible: false,
            types: {...DefaultTypes}
        });
    }

    confirm = () => {
        const { types: { all, detail, allCure, detailCure }, monthParams } = this.state;
        const { allSolidifyDate, detailSolidifyDate } = monthParams;
        if(!(all || detail || allCure || detailCure)){
            message.warning('请选择需要导出的内容');
            return;
        }
        const { searchParams, pagination } = this.props;
        const { areaParams = {}, hasCheckedArea, ...rest } = searchParams;
        const url = API_URL.manhour.exportManHourCrccOrCrcm;
        if (all) {
            ExportUtil.export({ ...areaParams, ...rest, type: 'all' }, pagination, url);
        }
        if (detail) {
            addToDownloadSite({ ...areaParams, ...rest, ...pagination, type: 'detail' }, url, 'USER_MONTH_FTE');
        }
        if (allCure) {
            ExportUtil.export({ ...areaParams, ...rest, type: 'all', solidifyDate: allSolidifyDate }, pagination, url);
        }
        if (detailCure) {
            addToDownloadSite({ ...areaParams, ...rest, ...pagination, type: 'detail', solidifyDate: detailSolidifyDate }, url, 'USER_MONTH_FTE');
        }
        this.hide();
    }

    handleChange = (e, key) => {
        const { types } = this.state;
        types[key] = e.target.checked;
        this.setState({ types });
    }

    handleMonthChange = (value, key) => {
        const { monthParams } = this.state;
        monthParams[key] = value;
        this.setState({ monthParams });
    }

    render() {
        const { visible, types, monthParams } = this.state;
        const { allSolidifyDate, detailSolidifyDate } = monthParams;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item" style={{ width: '40%' }}>
                                <label className="ui-label" style={{width: 155}}>请选择需要导出的内容</label>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item checkBoxchildren" >
                                <div><Checkbox onChange={e => this.handleChange(e, 'all')} checked={types['all']} value="all">员工工时汇总查询</Checkbox></div>
                                <div><Checkbox onChange={e => this.handleChange(e, 'detail')} checked={types['detail']} value="detail">员工工时详情</Checkbox></div>
                                <div>
                                    <Checkbox 
                                        onChange={e => this.handleChange(e, 'allCure')} 
                                        checked={types['allCure']} 
                                        value="allCure"
                                    >
                                        员工工时汇总查询（岗位固化）
                                    </Checkbox>
                                    <MonthPicker
                                        allowClear={false}
                                        style={{ margin: '0px 0px 10px 10px', width: 180 }}
                                        value={allSolidifyDate ? moment(allSolidifyDate) : null}
                                        placeholder="请选择月份"
                                        onChange={(date, dateString) => this.handleMonthChange(dateString, 'allSolidifyDate')}
                                    />
                                </div>
                                <div>
                                    <Checkbox 
                                        onChange={e => this.handleChange(e, 'detailCure')} 
                                        checked={types['detailCure']} 
                                        value="detailCure"
                                    >
                                        员工工时详情（岗位固化）
                                    </Checkbox>
                                    <MonthPicker
                                        allowClear={false}
                                        style={{ margin: '0px 0px 10px 10px', width: 180 }}
                                        value={detailSolidifyDate ? moment(detailSolidifyDate) : null}
                                        placeholder="请选择月份"
                                        onChange={(date, dateString) => this.handleMonthChange(dateString, 'detailSolidifyDate')}
                                    />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export default ExportModal;


// WEBPACK FOOTER //
// ./src/components/manHour/query/ExportModal.js